import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=53aee195&scoped=true&"
import script from "./complaints.vue?vue&type=script&lang=js&"
export * from "./complaints.vue?vue&type=script&lang=js&"
import style0 from "./complaints.vue?vue&type=style&index=0&id=53aee195&scoped=true&lang=less&"
import style1 from "./complaints.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aee195",
  null
  
)

export default component.exports